import {
    Component,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
    Validators,
    FormGroup,
    FormBuilder
} from '@angular/forms';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { ErrorService } from 'app/shared/services/error.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentService } from '../../../services/student.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-student-email-edit',
    templateUrl: './student-email-edit.component.html',
    styleUrls: ['./student-email-edit.component.scss']
})
export class StudentEmailEditComponent implements OnInit {
    @Output() toggleShowStudentEmailEditOutput = new EventEmitter<boolean>();
    @ViewChild(MatButton) submitButton: MatButton;

    studentEmailEditForm: FormGroup;
    showEmailEditInvalid = false;
    studentEmailEditErrorMessage: string;

    error_messages = {
        currentEmail: [
            { type: 'required', message: 'Please enter your current email' },
            { type: 'email', message: 'Please provide a valid email' }
        ],
        newEmail: [
            { type: 'required', message: 'Please enter your new email' },
            { type: 'email', message: 'Please provide a valid email' },
            { type: 'mustNotMatch', message: 'New email must differ to current email' }
        ],
        confirmEmail: [
            { type: 'required', message: 'Please confirm your new email' },
            { type: 'email', message: 'Please provide a valid email' },
            { type: 'mustMatch', message: 'Emails must match' }

        ]
    };

    constructor(
        private formBuilder: FormBuilder,
        private studentService: StudentService,
        private loader: AppLoaderService,
        private errorService: ErrorService,
        private _snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<StudentEmailEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
    }

    ngOnInit() {
        this.studentEmailEditForm = this.formBuilder.group({
                currentEmail: [
                    this.data.student.personalDetails.email,
                    [Validators.required, Validators.email]
                ],
                newEmail: ['',
                    [Validators.required, Validators.email]
                ],
                confirmEmail: ['', [Validators.required, Validators.email]
                ]
            },
            {
                validators: [
                    this.fieldMatch(true, 'newEmail', 'confirmEmail'),
                    this.fieldMatch(false, 'currentEmail', 'newEmail')
                ]
            }
        );
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    get formControls() {
        return this.studentEmailEditForm.controls;
    }

    fieldMatch(match: boolean, controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];

            if (matchingControl.errors
                && ((match && !matchingControl.errors.mustMatch)
                    || (!match && !matchingControl.errors.mustNotMatch))) {
                // return if another validator has already found an error on the matchingControl
                return;
            }

            // set error on matchingControl if validation fails
            if (match && control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else if (!match && control.value === matchingControl.value) {
                matchingControl.setErrors({ mustNotMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    async onSubmit() {
        if (!this.studentEmailEditForm.invalid) {
            this.showEmailEditInvalid = false;
            const studentEmailEditData = this.studentEmailEditForm.value;
            await window.scrollTo(0, 0);
            try {
                this.loader.open('Please wait');
                await this.studentService.studentEmailUpdate(studentEmailEditData);
                this.studentService.clearCache('student');
                this.loader.close();
                this.toggleShowStudentEmailEditOutput.emit(false);
                this.dialogRef.close(true);
                this._snackBar.open(
                    'Email successfully updated!',
                    'Close',
                    {
                        duration: 8000,
                        panelClass: ['success-snackbar']
                    }
                );
            } catch (err) {
                this.loader.close();
                this.showEmailEditInvalid = true;
                this.studentEmailEditErrorMessage = this.errorService.mapError(
                    JSON.parse(err.response).message
                );
            }
        }
    }
}
